module.exports = __webpack_public_path__ + "img/数据 (2).1da7fb5a.png";